import { combineReducers } from 'redux';
import { dateFilterReducer } from './components/MainAgenda/components/Header/reducer'
import uiReducer from './dux/ui/reducer'

const selectedReducer = (state = {}, { type, payload }) => {
  switch(type){
    case "UPDATE_SELECTED":
    return payload
    default:
      return state
  }
}

export default combineReducers({
  config: (state={}) => state,
  current_user: (state = {}) => state,
  dateFilter: dateFilterReducer,
  groups: (state = []) => state,
  organization: (state ={}) => state,
  residents: (state = []) => state,
  selected: selectedReducer,
  staff: (state = []) => state,
  ui: uiReducer,
  resident: (state = {}) => state,
});